import React, { useState, useEffect } from "react";
import {
    Card,
    Box,
    Typography,
    TextField,
    Button,
    MenuItem,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { ReactComponent as LockIcon } from '../../assets/svg/lock.svg';
import { ReactComponent as TimerIcon } from '../../assets/svg/timer.svg';
import HowToRegIcon from '@mui/icons-material/HowToReg';
import '../../css/App.css';

const VerifyOTPSignup = () => {

    const navigate = useNavigate();

    return (
        <Box className="primary-box">
            <Box className="secondary-box">
                <Card className="auth-card"
                    sx={{
                        p: 3
                    }}
                >
                    {/* Icon */}
                    <Box className="auth-lock"
                        sx={{
                            mx: "auto",
                            mb: 2,
                        }}
                    >
                        <LockIcon />
                    </Box>

                    {/* Title */}
                    <Typography
                        variant="h5"
                        sx={{ fontWeight: 600, mb: 2, textAlign: "center" }}
                    >
                        Verify your phone
                    </Typography>

                    <Typography
                        variant="h6"
                        sx={{ fontWeight: 'lighter', mb: 2, textAlign: "center" }}
                    >
                        Enter the 4-digit code sent to +971 1234567890
                    </Typography>

                    <>
                        {/* otp field */}
                        <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
                            {[0, 1, 2, 3].map((_, index) => (
                                <TextField
                                    key={index}
                                    inputProps={{
                                        maxLength: 1,
                                        style: { textAlign: "center", fontSize: "1.2rem" },
                                    }}
                                    size="small"
                                    sx={{ width: "25%" }}
                                />
                            ))}
                        </Box>
                    </>

                    {/* Submit Button */}
                    <Button
                        fullWidth
                        variant="contained"
                        // onClick={handleSubmit}
                        sx={{
                            textTransform: "none",
                            fontWeight: "bold",
                            backgroundColor: "#C32032",
                            mb: 1,
                        }}
                        onClick={()=>navigate('/')}
                    >
                        Verify & Create Account<HowToRegIcon />
                    </Button>

                    {/* resend otp */}
                    <Box sx={{ display: 'flex', gap: "4px", justifyContent: 'center' }}>
                        <Typography
                            variant="body2"
                            sx={{
                                textAlign: "center",
                                color: "#000",
                            }}
                        >
                            Don't receive the code?
                        </Typography>
                        <Typography
                            variant="body2"
                            sx={{
                                textAlign: "center",
                                cursor: "pointer",
                                textDecoration: "underline",
                                color: "#C32032",
                            }}
                        >
                            Resend OTP
                        </Typography>
                    </Box>

                    <Box sx={{ marginTop: '2%' }}>
                        <Typography
                            variant="body2"
                            className="otp-timer-text"
                            sx={{
                                gap: 1,
                            }}
                        >
                            {/* <TimerIcon fontSize="small" /> */}
                            {/* OTP valid for 10:00 minutes */}
                        </Typography>
                    </Box>

                </Card>
            </Box>
        </Box>
    );
};

export default VerifyOTPSignup;